import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import fish from './fish/reducers'

export default (history, i18n) => combineReducers({
  router: connectRouter(history),
  i18n,
  fish: fish,
})
